<template>
  <div id="wrapper">
    <div class="container" v-if="showCookieWarning">
    <div class="row">
    <div class="col-md-10 col-md-offset-1 mt-5">
      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <div class="d-flex flex-row justify-content-between align-items-center card cookie p-3">
            <div class="d-flex flex-row align-items-center"><img src="/static/assets/images/cookie.png" width="40">
              <div class="ml-2 mr-2">
                <span>We use third party cookies to personalize content and analyze site traffic. By using this website, you automatically accept that we use cookies</span><a class="learn-more" href="https://colonylive.b-cdn.net/wp-content/uploads/2021/03/COLONYLive-web-Privacy-policy.pdf"> Learn more<i class="fa fa-angle-right ml-2"></i></a></div>
            </div>
            <div><button @click="acceptCookies" class="btn btn-primary" type="button">Got It</button></div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    <div id="login-component" class="mt-5">
      <div class="bg-purple">
        <img class="logo" src="../../assets/images/logos/logo-white-live.svg" />
        <img class="page-icon" src="static/assets/icons/auth/lock.png" />
      </div>
      <div class="bg-grey text-white text-center welcome-text">
        <h4>A warm welcome to you</h4>
        <p>Login and feel free to leave us your feedback.</p>
      </div>
      <div class="text-center">
        <el-alert v-if="hasFailed" title="Login Failed" type="error" description="Sorry, your email address or password is incorrect">
        </el-alert>
        <el-form :model="loginForm" :rules="loginFormRules" ref="loginForm" class="login-form" @keyup.enter.native="onClickLogin">
          <el-form-item prop="email">
            <el-input :disabled="isPending" placeholder="Email" v-model="loginForm.email"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input :disabled="isPending" placeholder="Password" type="password" v-model="loginForm.password"></el-input>
          </el-form-item>
          <el-button id="login-btn" @click="onClickLogin" type="primary" :loading="isPending">Login</el-button>
        </el-form>
        <br>
        <strong>
          <router-link class="text-light-grey" :to="{ name: 'PasswordReset' }">Forgot Password?</router-link>
        </strong>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppFooter from '@/components/app/AppFooter';

export default {
  name: 'LoginForm',
  components: {
    AppFooter,
  },
  props: {
    isPending: {
      type: Boolean,
      default: false,
    },
    hasFailed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showCookieWarning: true,
    loginForm: {
      email: null,
      password: null,
    },
    loginFormRules: {
      email: [
        {
          type: 'email',
          required: true,
          message: 'Please enter your email address',
          trigger: 'blur',
        },
      ],
      password: [
        {
          required: true,
          message: 'Please enter your password',
          trigger: 'blur',
        },
      ],
    },
  }),
  mounted() {
    this.showCookieWarning = !this.$cookies.isKey('acceptCookieUse');
  },
  methods: {
    acceptCookies() {
      this.showCookieWarning = false;
      this.$cookies.set('acceptCookieUse', true, Infinity);
    },
    onClickLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$emit('onLogin', {
            email: this.loginForm.email,
            password: this.loginForm.password,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

#wrapper {
  background: $white;
  height: 100%;
  width: 100%;
}

#login-component {
  padding-top: 10px;
  width: 300px;
  margin: 0 auto;
}

#login-btn {
  width: 100%;
  background: $colony-primary;
  border-color: $colony-primary;
  border-radius: 0;
}

.logo {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0;
  display: block;
}

.page-icon {
  width: 100px;
  margin: 0 auto;
  display: block;
  padding-bottom: 20px;
}

.welcome-text {
  padding: 20px;
  margin-bottom: 20px;

  p {
    font-size: 0.7em;
    letter-spacing: 0.08em;
    line-height: 1.8em;
  }

  h4 {
    font-weight: lighter;
    font-size: 0.95em;
    margin: 0px;
    text-transform: uppercase;
    letter-spacing: 0.15em;
  }
}

.el-form {
  margin-top: 20px;
}

body {
    background: #BCBCCC
}

.card {
    flex-direction: column;
    min-width: 0;
    color: #000;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid #fff;
    border-radius: 6px;
    -webkit-box-shadow: 0px 0px 5px 0px rgb(249, 249, 250);
    -moz-box-shadow: 0px 0px 5px 0px rgba(212, 182, 212, 1);
    box-shadow: 0px 0px 5px 0px rgb(161, 163, 164)
}

.learn-more {
    text-decoration: none;
    color: rgb(104, 48, 144);;
    margin-top: 8px
}

.learn-more:hover {
    text-decoration: none;
    color: blue;
    margin-top: 8px
}

.d-flex {    display: -ms-flexbox!important;
  display: flex!important;
}

.p-3 {
  padding: 1rem!important;
}
.flex-row {
  -ms-flex-direction: row!important;
  flex-direction: row!important;
}
.justify-content-between {
  -ms-flex-pack: justify!important;
  justify-content: space-between!important;
}
.align-items-center {
  -ms-flex-align: center!important;
  align-items: center!important;
}
.mt-5, .my-5 {
  margin-top: 3rem!important;
}

.ml-2, .mx-2 {
    margin-left: .5rem!important;
}

.mr-2, .mx-2 {
    margin-right: .5rem!important;
}
</style>



// WEBPACK FOOTER //
// LoginForm.vue?15d89e99